import React, { useEffect, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap"; // Import Spinner for loading state
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Ensure axios is imported
import { enqueueSnackbar } from "notistack"; // Ensure notistack is imported for notifications
import { FadeLoader } from "react-spinners";

const ProductsByCategory = ({ product }) => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  return (
    <Col className="sm-text-center" md={6} lg={3}>
      <div
        className="catalog-card"
        onClick={() => navigate(`/catalog-details/${product.slug}`)}
        style={{ cursor: "pointer" }}
      >
        <div className="product-item">
          <div className="product-img">
            <a>
              <img src={product.image} alt="image" />
            </a>
          </div>

          <div className="product-detail">
            <h4>
              <a href="#">{product.title}</a>
            </h4>
          </div>
        </div>
      </div>
    </Col>
  );
};

// const ProductsByCategory = () => {
//   const [catalogs, setCatalogs] = useState([]); // State to store fetched catalogs
//   const [loading, setLoading] = useState(true); // State to manage loading state
//   const [error, setError] = useState(false); // State to manage error state

//   const getAllCatalogs = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         "https://naqshzari.com/backend/public/api/get-all-catalogs",
//         {
//           headers: {
//             Accept: "application/json",
//           },
//         }
//       );
//       if (response.data.status === 200) {
//         setCatalogs(response.data.data);
//       } else {
//         enqueueSnackbar("Internal Server Error", {
//           variant: "error",
//           autoHideDuration: 2000,
//         });
//         setError(true);
//       }
//     } catch (error) {
//       enqueueSnackbar("Internal Server Error", {
//         variant: "error",
//         autoHideDuration: 2000,
//       });
//       setError(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     getAllCatalogs(); // Fetch catalogs on component mount
//   }, []);

//   if (loading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <FadeLoader color={"#000000"} loading={loading} width={3} height={10} />
//       </div>
//     );
//   }

//   if (error || catalogs.length === 0) {
//     return (
//       <h3 className="text-center font-weight-bold">
//         No catalogs available at the moment.
//       </h3>
//     );
//   }

//   return (
//     <Row>
//       {catalogs.map((product, index) => (
//         <ProductItem key={index} product={product} />
//       ))}
//     </Row>
//   );
// };

export default ProductsByCategory;
